import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { debounceTime, skip } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-deistribution-fertilizer',
  templateUrl: './deistribution-fertilizer.component.html',
  styleUrls: ['./deistribution-fertilizer.component.scss']
})
export class DeistributionFertilizerComponent {

  UserDetails: any;
  targetForm!: FormGroup;
  blockList: any[] = [];
  financialYears: any[] = [];
  fertilizerData: any[] = [];
  circlesList: any[] = [];
  consumerGoodsForm!: FormGroup;
  fertilizerForm!: FormGroup;
  rows: any[] = [];
  months: any[] = [];
  fertilizerTypes: any[] = [];
  showButton = false
  currentMonth: any = {};
  monthKeyMap: Record<number, string> = {
  1: 'april',
  2: 'may',
  3: 'june',
  4: 'july',
  5: 'august',
  6: 'september',
  7: 'october',
  8: 'november',
  9: 'december',
  10: 'january',
  11: 'february',
  12: 'march'
  };
  constructor(private reportService: ReportsService, private authService: AuthService, private fb: FormBuilder, private toastService: ToastService) {

  }

  ngOnInit(): void {

    this.targetForm = this.fb.group({
      financialYear: ['', Validators.required],
      blockOffice: ['', Validators.required],

    });


    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;




    const today = new Date();
    const currentMonthYear = today.toISOString().slice(0, 7); // format: "2025-09"

  this.initForm()
    // // this.GetConsumerGoods();.
    this.getTargetCount();
    this.GetYearAndMonth();
    this.getFertilizerTypes();

          switch (this.UserDetails?.roleId) {
      case 13:
       
        break;
      case 1:
             this.targetForm.addControl('circleOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));
       this.getCircle();
        break;
      case 11:
        this.targetForm.controls['blockOffice'].disable();
       
    
        break;
      default:
    }
      this.targetForm.valueChanges
            .pipe(debounceTime(300))  // waits 300ms after last change
            .subscribe(values => {
              if (this.targetForm.valid) {
                this.GetTFertilizerSalePurchase();
              }
            });
  }

  initForm(){
       this.fertilizerForm = this.fb.group({
      financialYear: [{ value: '', disabled: true }, Validators.required],
      blockOffice: [{ value: '', disabled: true }, Validators.required],
      dataMonth: [{ value: '', disabled: false }, Validators.required],
      fertilizerList: this.fb.array([
        this.fb.group({
          kindOfFertilizer: ['Ammonium Sulphate'],
          openingStockQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          openingStockAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],

        }),
        this.fb.group({
          kindOfFertilizer: ['DAP'],
          openingStockQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          openingStockAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],

        }),
        this.fb.group({
          kindOfFertilizer: ['MOP 60%'],
          openingStockQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          openingStockAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],

        }),
        this.fb.group({
          kindOfFertilizer: ['NPK (10:26:26)'],
          openingStockQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          openingStockAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],

        }),
        this.fb.group({
          kindOfFertilizer: ['NPK (12:32:16)'],
          openingStockQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          openingStockAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],

        }),
        this.fb.group({
          kindOfFertilizer: ['NPK (15:15:15)'],
          openingStockQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          openingStockAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],

        }),
        this.fb.group({
          kindOfFertilizer: ['Others'],
          openingStockQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          openingStockAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],

        }),
        this.fb.group({
          kindOfFertilizer: ['SSP'],
          openingStockQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          openingStockAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],

        }),
        this.fb.group({
          kindOfFertilizer: ['Urea'],
          openingStockQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          openingStockAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          purchaseAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          saleAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],

        }),

        // Add more fertilizers as needed
      ])
    });
  }
  get fertilizersFormArray(): FormArray {
    return this.fertilizerForm.get('fertilizerList') as FormArray;
  }
    getFertilizerTypes() {
 
     this.reportService.getFertilizerTypes().subscribe((res: any) => {
       if (res) {
         // this.circlesList = res.data.circles;
         this.fertilizerTypes = res.data;
        
 
       }
     },
       (error: any) => {
       }
     );
   }

   setFertilizerTypes(){
         // Dynamically add FormGroups to FormArray
  const fertilizerArray:any = this.fertilizerForm.get('fertilizerList') as FormArray;

  this.fertilizerTypes.forEach((f,i) => {
     fertilizerArray.controls[i].controls['kindOfFertilizer'].setValue(f.fertilizerName) 
    // push(this.fb.group({
    //   kindOfFertilizer: [f.fertilizerName],
    //   openingStockQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
    //   openingStockAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
    //   purchaseQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
    //   purchaseAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
    //   saleQty: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
    //   saleAmt: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]]
    // }));
  });
   }
  getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {
        // this.circlesList = res.data.circles;
        if(this.UserDetails?.roleId !== 1){
       this.blockList = res.data.blocks;
        }
 
          this.financialYears = res.data.financialYears
           if(this.UserDetails?.roleId ==11){
          this.targetForm.controls['blockOffice'].setValue(this.UserDetails?.iBlockId);
            this.targetForm.controls['blockOffice'].disable();
        }
      }
    },
      (error: any) => {
      }
    );
  }
  getCircle() {
  
    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.circlesList = res.data.circles;
        
 
    
      }
    },
      (error: any) => {
      }
    );
  }

   GetBlock() {


    let obj = {
      // "action": "GetBIDropdownValue",
      "blockId":0,
      "circleId": this.targetForm.value?.circleOffice
      // "circleId": 0
    }
 
    
    this.reportService.GetBlock(obj).subscribe((res: any) => {
      if (res) {
            
        this.blockList = res.data?.block;
          this.targetForm.controls['blockOffice'].setValue('');
    
      }
    },
      (error: any) => {
      }
    );
  }
  GetYearAndMonth() {

    this.reportService.GetYearAndMonth({}).subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;


        // this.financialYears = res.data.financialYears
        this.months = res.data.months


      }
    },
      (error: any) => {
      }
    );
  }

  GetTFertilizerSalePurchase() {
    let obj = {
      blockId: this.targetForm.getRawValue().blockOffice.toString(),
      "financialYear": this.targetForm.value?.financialYear?.financialYear
    }
    this.reportService.GetTFertilizerSalePurchase(obj).subscribe((res: any) => {

      if (res && res?.data && res?.data.length > 0) {
        let lastRow = res?.data[res?.data.length - 1];

        this.fertilizerData = res?.data
        this.groupByMonth();
           if (Number(lastRow?.dataMonth) != 12 && Number(lastRow?.dataMonth) < 12) {
                    let fyear = this.targetForm.getRawValue()?.financialYear.financialYear
                 let year = (Number(lastRow?.dataMonth) <= 9)? fyear?.split('-')[0] :fyear.split('-')[1] 
           this.currentMonth.key = (Number(lastRow?.dataMonth) + 1).toString();
            this.currentMonth.name = this.monthKeyMap[(Number(lastRow?.dataMonth) + 1)] + ', ' + year;     
                  this.showButton = true
          } else {
          this.showButton = false
        }


      } else {
        this.fertilizerData = []
        this.groupedData = []
        this.initForm();
        this.showButton = true;
        this.currentMonth.name = this.monthKeyMap['1'] + ', ' + this.targetForm.value?.financialYear?.startYear
        this.currentMonth.key = '1';
        this.toastService.showInfo('NO Data Found!')
      }
    },
      (error: any) => {
      }
    );
  }
  groupedData: {
    dataMonth: number;
    monthName: string;
    financialYear: string;
    isVerified: boolean;
    fertilizers: any[];
  }[] = [];



  groupByMonth(): void {
    const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
      'October', 'November', 'December', 
    ];

    const grouped = new Map<number, any>();

    for (const item of this.fertilizerData) {
      const month = item.dataMonth;
      const isVerified = item.isVerified;
      const blockOffice = item.blockOffice;

      if (!grouped.has(month)) {
        grouped.set(month, {
          dataMonth: month,
          monthName: `${monthNames[month-1]}, ${item.financialYear.split('-')[0]}`,
          financialYear: item.financialYear,
          isVerified: isVerified,
          blockOffice: blockOffice,
          fertilizers: []
        });
      }

      grouped.get(month).fertilizers.push(item);
    }

    this.groupedData = Array.from(grouped.values());

  }


  addData() {
        let lastItem:any
if(this.groupedData && this.groupedData.length >0){
  lastItem =this.groupedData[this.groupedData.length -1]
}

    this.fertilizerForm.patchValue({
      financialYear: this.targetForm.value?.financialYear?.financialYear,
      blockOffice: this.targetForm.getRawValue()?.blockOffice,
      dataMonth: this.currentMonth.key,
     
    });
      this.fertilizerForm.controls['dataMonth'].disable();
  if(lastItem){
  const formArray:any = this.fertilizerForm.get('fertilizerList') as FormArray;

  // Loop through incoming fertilizers
  lastItem.fertilizers.forEach((fert:any) => {
    const index = formArray.controls.findIndex(
      (ctrl:any) => ctrl.get('kindOfFertilizer')?.value === fert.kindOfFertilizer
    );

    if (index !== -1) {
      formArray.at(index).patchValue({
        openingStockQty:fert ? (fert.openingStockQty + fert.purchaseQty - fert.saleQty) : 0,
      openingStockAmt: fert ? (fert.openingStockAmt + fert.purchaseAmt - fert.saleAmt) : 0,

        purchaseQty: 0,
        purchaseAmt: 0,
        saleQty: 0,
        saleAmt: 0,
      });
      formArray.controls[index]?.controls['openingStockQty'].disable()
      formArray.controls[index]?.controls['openingStockAmt'].disable()

    }
    else{
            formArray.controls[index]?.controls['openingStockQty'].enable()
      formArray.controls[index]?.controls['openingStockAmt'].enable()
    }

  })
}
}


  onSubmit() {
    if (this.fertilizerForm.valid) {
      // 🔑 getRawValue() ensures disabled fields are included
      const payload = this.fertilizerForm.getRawValue();
      let obj = {
        "createdBy": this.edit ? 0 : this.UserDetails?.id,
        "modifiedBy": this.edit ? this.UserDetails?.id : 0,
        id: this.edit ? this.editId : 0,
        ...payload

      }


      this.reportService.AddTFertilizerSalePurchase(obj).subscribe((res: any) => {
        if (res) {
          if (res?.status == 200) {
            this.toastService.showSuccess(res.message);

            this.hideModal('FertilizerSalePurchaseDataModal');
            this.fertilizerForm.reset();
            this.fertilizerForm.markAsUntouched();
            this.setFertilizerTypes();
            this.GetTFertilizerSalePurchase();
          }else{
    this.edit = false
          }

        }
    
      },
        (error: any) => {
        }
      );


    } else {
      this.fertilizerForm.markAllAsTouched();
    }
  }

  edit = false;
  editId = 0


  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }

  editRow(row: any) {

    const data = row;
    const headerData = this.targetForm.getRawValue();

this.prefillForm(row)
 
    this.editId = 0
    this.edit = true

    this.openModal('FertilizerSalePurchaseDataModal');
  }

// Example method
prefillForm(fertilizerData: any): void {
  // Set top-level form fields
  this.fertilizerForm.patchValue({
    financialYear: fertilizerData.financialYear,
    blockOffice: fertilizerData.blockOffice,
    dataMonth: fertilizerData.dataMonth,
  });

  // Get the form array
  const formArray = this.fertilizerForm.get('fertilizerList') as FormArray;

  // Loop through incoming fertilizers
  fertilizerData.fertilizers.forEach((fert:any) => {
    // Find matching fertilizer by kindOfFertilizer
    const index = formArray.controls.findIndex(
      ctrl => ctrl.get('kindOfFertilizer')?.value === fert.kindOfFertilizer
    );

    if (index !== -1) {
      formArray.at(index).patchValue({
        openingStockQty: fert.openingStockQty,
        openingStockAmt: fert.openingStockAmt,
        purchaseQty: fert.purchaseQty,
        purchaseAmt: fert.purchaseAmt,
        saleQty: fert.saleQty,
        saleAmt: fert.saleAmt,
      });
    }
  });
}


  DeleteTFertilizerSalePurchase(row: any) {


    let payload = {
      "blockId": row?.blockOffice,
      "financialYear": row?.financialYear,
      "dataMonth": row?.dataMonth
    }


    this.reportService.DeleteTFertilizerSalePurchase(payload).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteRow = null;
          // this.hideModal();
          this.GetTFertilizerSalePurchase();
        }

      }
    },
      (error: any) => {
      }
    );
  }

  verifyFertilizerSalePurchase(row: any) {
    let payload = {
      "blockId": row?.blockOffice,
      "financialYear": row?.financialYear,
      "dataMonth": row?.dataMonth
    }

    this.reportService.verifyFertilizerSalePurchase(payload).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);

          // this.hideModal();
          this.GetTFertilizerSalePurchase();
        }

      }
    },
      (error: any) => {
      }
    );
  }
  getMonthName(month: string | number): string {
    const months = [
     'April', 'May', 'June', 'July', 'August', 'September',
      'October', 'November', 'December' ,'January', 'February', 'March'
    ];
    const index = +month - 1;
    return months[index] || 'Unknown';
  }

  getYearFromFinancialYear(financialYear: string, month: string | number): string {
    const [startYear, endYear] = financialYear.split('-');
    const monthNum = +month;
    return monthNum >= 1 && monthNum <= 9 ? startYear : endYear;
  }

  deleteRow: any
  setDeleteIndex(row: any) {
    this.deleteRow = row;
  }
  cancelDelete() {
    this.deleteRow = null;

  }
  closeModel() {
    this.fertilizerForm.reset()
    this.fertilizerForm.markAsUntouched();
    this.setFertilizerTypes();
    this.editId = 0
    this.edit = false
  }
}
